import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

/**
 * Settings REST calls for app initialization
 */
export class AppInitSettingsService {
  private readonly http = inject(HttpClient);

  configuration: any = [];

  /**
   * Load configuration from file, the configuration will be accessible through configuration[name]
   * @param path path to get the config from
   */
  getSettingsFromFile(path: string, name: string): Promise<any | undefined> {
    return firstValueFrom(
      this.http.get<any>(path).pipe(
        tap((result) => {
          (this.configuration as any)[name] = result;
        }),
      ),
    );
  }
}
